export const tableViewOrg = [
  { id: "reviewed" },
  { id: "lastName" },
  { id: "firstName" },
  { id: "id" },
  { id: "view" },
  { id: "color" },
  { id: "attachments" },
  { id: "hcfa1500" },
  { id: "encounterType" },
  { id: "status" },
  { id: "provider" },
  { id: "address" },
  { id: "zip" },
  { id: "state" },
  { id: "createdOn" },
  { id: "lastUpdate" },
  { id: "visitTime" },
  { id: "dob" },
  { id: "gender" },
  { id: "userAge" },
  { id: "insuranceCarrier" },
  { id: "policyNumber" },
  { id: "groupNumber" },

  { id: "patientInsuredName" },
  { id: "patientInsuredDob" },
  { id: "patientStreetAddress" },
  { id: "patientCity" },
  { id: "patientState" },
  { id: "patientZip" },
  { id: "patientOtherInsured" },
  { id: "patientOtherInsuredPolicyGroup" },
  { id: "patientOtherInsuredPlanName" },

  // Additional HCFA 1500 fields
  { id: "dateOfCurrentIllnessInjury" },
  { id: "similarIllnessDate" },
  { id: "datesUnableToWorkFrom" },
  { id: "datesUnableToWorkTo" },
  { id: "hospitalizationFrom" },
  { id: "hospitalizationTo" },
  { id: "additionalClaimInformation" },
  { id: "outsideLabCharges" },
  { id: "medicaidOtherResubmissionCode" },
  { id: "originalReferenceNumber" },
  { id: "priorAuthorizationNumber" },

  { id: "sponsorInfo" },
  { id: "noteReviewed" },
  { id: "verificationStatus" },
  { id: "verificationNotes" },
  { id: "verificationFinalStatus" },
  { id: "dateVerifiedProcessCompleted" },
  { id: "billedUnitsUsed" },
  { id: "billedUnitsWasted" },
  { id: "authRemainedUnits" },
  { id: "dateOfService" },
  { id: "dateNoteReceived" },
  { id: "dateBilled" },
  { id: "dateReceived" },
  { id: "amountBilled" },
  { id: "eftDate" },
  { id: "amountPaid" },
  { id: "unitsPaid" },
  { id: "claimNumber" },
  { id: "eftNumber" },
  { id: "finalStatus" },
  { id: "finalStatusNote" },
  { id: "statusActionDate" },
  { id: "projectAdjudicationDate" },
  { id: "eobAttached" },
  { id: "resolution" },
  { id: "denialReason" },
  { id: "appealLevel" },
  { id: "appealDeadline" },
  { id: "previousTreatments" },
  { id: "productPrice" },
  { id: "invoiceNumber" },
  { id: "invoiceAmount" },
  { id: "invoiceAmountPaid" },
  { id: "miscCharge" },
  { id: "netAmount" },
  { id: "amoutOtstanding" },
  { id: "dateAppealSent" },
  { id: "paymentDate" },

  // WOUND INFORMATION

  { id: "woundOnsetDate" },
  { id: "prevTxDetailsCompleted" },
  { id: "patientTreatmentLocation" },
  { id: "woundImagesAvailable" },
  { id: "woundClassification" },
  { id: "woundSiteLocation" },
  { id: "totalSurfaceArea" },
  { id: "totalAreaWithDepth" },
  { id: "percentImprovement" },
  { id: "productApplicationDateOfService" },
  { id: "trackingNumber" },

  // Note info
  { id: "hpi" },
  { id: "pastMedicalHistory" },
  { id: "pastSurgeries" },
  { id: "allergies" },
  { id: "currentMedications" },
  { id: "familyHistory" },
  { id: "socialHistory" },
  { id: "ros" },
  { id: "physicalExams" },
  { id: "totalWounds" },
  { id: "diagnostics" },
  { id: "uploadedTot_labs" },
  { id: "planOfCare" },
  { id: "inOfficeProcedures" },
  // { id: "cpt2codes" },
  { id: "billableCodesICD10" },
  { id: "cpt2Wounds" },
  { id: "medicalDecisionMaking" },
];
